import templateUrl from './edit-payroll-policy.component.html';
import { overtimeTypes } from './overtime-types';

export const EditPayrollPolicyComponent = {
    templateUrl,
    controller: EditPayrollPolicyController,
    controllerAs: "vm",
    require: {
        payrollPolicyForm: "?^^form"
    },
    bindings: {
        payrollPolicy: "<",
        payrollTypes: "<",
        isOverride: "<?",
        isAbstract: "<?"
    }
};

function EditPayrollPolicyController() {
    const vm = this;
    // If true, provide options for "Default" which represent a fallback option.
    vm.isOverride;
    // If true, certain concrete fields will be hidden.
    vm.isAbstract;
    vm.onChange = function () {
        if (vm.payrollPolicyForm) {
            vm.payrollPolicyForm.$setDirty(true);
        }
    };
    vm.payrollPolicy;
    vm.payrollPolicyForm;
    vm.payrollTypes;
    vm.$onInit = onInit;

    function onInit() {
        vm.overtimeTypes = overtimeTypes;
    }
}
